// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__AZK6U","logo":"Sidebar_logo__x+VRK","menu":"Sidebar_menu__w1A6-","menuItem":"Sidebar_menuItem__aHREO","logout":"Sidebar_logout__68UMd"};